import {
  ExceptionalOpeningHoursDay,
  OpeningHoursDay,
  ServicePageStoreFragment,
} from '@business/gql/graphql';
import { cn } from '@ngg/storefront-utils';
import {
  getIrregularOpeningHoursDisplayData,
  getOpeningHoursDisplayData,
} from '@utils/content/getOpeningHours';
import { getPhoneNumberForLink } from '@utils/content/getPhoneNumberForLink';
import useDictionary from '@utils/hooks/useDictionary';
import { Heading } from '../Heading/Heading';
import Paragraph from '../Paragraph/Paragraph';

export const StoreInfo = ({
  storeData,
  className,
}: {
  storeData?: ServicePageStoreFragment;
  className: string;
}) => {
  const dictionary = useDictionary({
    keys: [
      'closed',
      'contactUs',
      'email',
      'findHere',
      'phoneNumber',
      'address',
      'openingHours',
      'irregularOpeningHours',
      'openingHoursServiceTeam',
    ],
  });
  const openingHoursData = storeData?.openingHoursCollection
    ?.items as OpeningHoursDay[];
  const irregularOpeningHours = storeData?.exceptionalOpeningHoursCollection
    ?.items as ExceptionalOpeningHoursDay[] | undefined;

  const irregularDisplayData = irregularOpeningHours
    ? getIrregularOpeningHoursDisplayData(irregularOpeningHours, dictionary)
    : null;
  const displayData = getOpeningHoursDisplayData(
    openingHoursData,
    dictionary.closed,
  );
  const phoneNumber = getPhoneNumberForLink(storeData?.phoneNumber);

  return (
    <div className={cn('text-grey-300 text-xs', className)}>
      <div className="space-y-4">
        <div className="flex flex-col">
          <Heading as="h3" className="font-medium uppercase">
            {storeData?.title}
          </Heading>
          {storeData?.type === 'Online' && storeData?.email ? (
            <a className="underline" href={`mailto:${storeData.email}`}>
              {storeData.email}
            </a>
          ) : null}
          {storeData?.phoneNumber ? (
            <a className="underline" href={`tel:${phoneNumber}`}>
              {storeData.phoneNumber}
            </a>
          ) : null}
        </div>
        {displayData?.length ? (
          <div>
            <Heading as="h3" className="font-medium uppercase">
              {dictionary?.openingHoursServiceTeam}
            </Heading>
            {displayData.map((item) => (
              <Paragraph
                key={item?.text}>{`${item?.text}: ${item?.time}`}</Paragraph>
            ))}
          </div>
        ) : null}
        {irregularDisplayData?.length ? (
          <div>
            <Heading as="h3" className="mt-4 font-medium uppercase">
              {dictionary?.irregularOpeningHours}
            </Heading>
            {irregularDisplayData.map((item) => (
              <Paragraph
                key={item?.text}>{`${item?.text}: ${item?.time}`}</Paragraph>
            ))}
          </div>
        ) : null}
      </div>
    </div>
  );
};
